/* global __SERVER__ */
/* global __CLIENT__ */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shape, string, object, func, bool } from 'prop-types';
import { renderRoutes } from 'react-router-config';
import Rollbar from 'rollbar';

import './nprogress.scss';

import {
  getLanguage,
  getLocaleCode,
  getRegion,
} from '@dragonfruit/redux/locale';
import {
  storePreviousLocation,
  storeCurrentLocation,
  getIsInapp,
} from '@dragonfruit/redux/location';
import SEOHead from '@dragonfruit/components/SEOHead';
import { actions } from '@dragonfruit/redux/error';
import { actions as reportActions } from '@dragonfruit/redux/report';
import ApplicationContext from '@dragonfruit/components/ApplicationContext/ApplicationContext';

import config from '@dragonfruit/config';
const { NODE_ENV, ENABLED_ROLLBAR, ROLLBAR_CLIENT_ACCESS_TOKEN } = config;

const mapStateToProps = state => ({
  lang: getLanguage(state),
  urlLocale: getLocaleCode(state),
  region: getRegion(state),
  isInapp: getIsInapp(state),
});

class App extends Component {
  static propTypes = {
    hideReportForm: func.isRequired,
    history: shape({
      action: string,
    }).isRequired,
    isInapp: bool.isRequired,
    lang: string.isRequired,
    location: object.isRequired,
    region: string.isRequired,
    route: object.isRequired,
    sendError: func.isRequired,
    storeCurrentLocation: func.isRequired,
    storePreviousLocation: func.isRequired,
    urlLocale: string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      rollbar: new Rollbar({
        enabled: ENABLED_ROLLBAR === 'true',
        accessToken: ROLLBAR_CLIENT_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
          environment: NODE_ENV,
        },
      }),
    };
  }

  getChildContext = () => {
    const { lang, urlLocale, region } = this.props;

    return {
      lang,
      urlLocale,
      region,
    };
  };

  componentDidMount = () => {
    const { isInapp, hideReportForm } = this.props;

    // hide report form
    if (__CLIENT__ && isInapp) {
      hideReportForm();
    }
  };

  componentWillReceiveProps = nextProps => {
    const {
      location,
      storePreviousLocation,
      storeCurrentLocation,
    } = this.props;

    if (nextProps.location.pathname !== location.pathname) {
      storePreviousLocation(location.pathname);
      storeCurrentLocation(nextProps.location.pathname);
    }
  };

  componentDidUpdate = prevProps => {
    if (this.props.location !== prevProps.location) {
      const { history } = this.props;
      // @fixme is there a better to scroll page to the top after redirection?
      // ignore scroll to top when location contains hash.
      if (history.action === 'PUSH' && !history.location.hash) {
        window.scrollTo(0, 0);
      }
    }
  };

  componentDidCatch(error, info) {
    this.props.sendError(error, info);
  }

  render() {
    const { lang, urlLocale, route, history } = this.props;

    return (
      <div>
        {__SERVER__ && ( // SEO is only meaningful on the server side.
          <SEOHead
            schema="Service"
            contentType="product"
            lang={lang}
            urlLocale={urlLocale}
          />
        )}
        <ApplicationContext.Provider value={{ history }}>
          {renderRoutes(route.routes)}
        </ApplicationContext.Provider>
      </div>
    );
  }
}

App.childContextTypes = {
  lang: string,
  urlLocale: string,
  region: string,
};

export default connect(mapStateToProps, {
  storePreviousLocation,
  storeCurrentLocation,
  sendError: actions.sendError,
  hideReportForm: reportActions.hideReportForm,
})(App);



// WEBPACK FOOTER //
// ./app/containers/App/App.jsx